// extracted by mini-css-extract-plugin
export default {"footer-links-item__link":"c9F8tv"};